import { render, staticRenderFns } from "./ShipmentEmailChangeModal.vue?vue&type=template&id=6f759a15&scoped=true&"
import script from "./ShipmentEmailChangeModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentEmailChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f759a15",
  null
  
)

export default component.exports